import { Zap, Heart, Clock, Shield, Snowflake, Star, Crosshair } from 'lucide-react';
import { PowerUpType, ActivePowerUps } from '../types';

interface PowerUpDisplayProps {
  activePowerUps: ActivePowerUps;
  powerUpTimeLeft: {[key: string]: number};
}

const PowerUpIcon = ({ type, size = 'w-4 h-4' }: { type: PowerUpType; size?: string }) => {
  switch (type) {
    case 'speed': return <Zap className={`${size} text-yellow-400`} />;
    case 'health': return <Heart className={`${size} text-red-500`} />;
    case 'slowZombies': return <Clock className={`${size} text-blue-400`} />;
    case 'doubleDamage': return <Shield className={`${size} text-purple-400`} />;
    case 'shield': return <Shield className={`${size} text-cyan-400`} />;
    case 'rapidFire': return <Crosshair className={`${size} text-orange-400`} />;
    case 'freezeZombies': return <Snowflake className={`${size} text-blue-200`} />;
    case 'scoreMultiplier': return <Star className={`${size} text-yellow-300`} />;
    default: return null;
  }
};

const PowerUpDisplay = ({ activePowerUps, powerUpTimeLeft }: PowerUpDisplayProps) => {
  return (
    <div className="absolute bottom-4 left-4 bg-black bg-opacity-70 px-4 py-2 rounded-lg max-w-xs">
      <p className="text-sm text-gray-300 mb-1">ACTIVE POWERUPS:</p>
      <div className="grid grid-cols-2 gap-1 text-xs">
        {activePowerUps.speed && (
          <div className="flex items-center gap-1">
            <PowerUpIcon type="speed" />
            <span>{Math.ceil((powerUpTimeLeft.speed || 0) / 1000)}s</span>
          </div>
        )}
        {activePowerUps.slowZombies && (
          <div className="flex items-center gap-1">
            <PowerUpIcon type="slowZombies" />
            <span>{Math.ceil((powerUpTimeLeft.slowZombies || 0) / 1000)}s</span>
          </div>
        )}
        {activePowerUps.doubleDamage && (
          <div className="flex items-center gap-1">
            <PowerUpIcon type="doubleDamage" />
            <span>{Math.ceil((powerUpTimeLeft.doubleDamage || 0) / 1000)}s</span>
          </div>
        )}
        {activePowerUps.shield && (
          <div className="flex items-center gap-1">
            <PowerUpIcon type="shield" />
            <span>{Math.ceil((powerUpTimeLeft.shield || 0) / 1000)}s</span>
          </div>
        )}
        {activePowerUps.rapidFire && (
          <div className="flex items-center gap-1">
            <PowerUpIcon type="rapidFire" />
            <span>{Math.ceil((powerUpTimeLeft.rapidFire || 0) / 1000)}s</span>
          </div>
        )}
        {activePowerUps.freezeZombies && (
          <div className="flex items-center gap-1">
            <PowerUpIcon type="freezeZombies" />
            <span>{Math.ceil((powerUpTimeLeft.freezeZombies || 0) / 1000)}s</span>
          </div>
        )}
        {activePowerUps.scoreMultiplier && (
          <div className="flex items-center gap-1">
            <PowerUpIcon type="scoreMultiplier" />
            <span>{Math.ceil((powerUpTimeLeft.scoreMultiplier || 0) / 1000)}s</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PowerUpDisplay;
